import axios from 'axios';
export default {
    props: {
        modelValue: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            timeout: '',
            partSize: '',
            parallel: '',
            retryCount: '',
            retryDuration: '',
            region: 'cn-shanghai',
            userId: '1633016974551227',
            file: null,
            stsProgress: 0,
            uploadDisabled: true,
            resumeDisabled: true,
            pauseDisabled: true,
            statusText: '请选择文件',
            pauseDisabled: true,
            uploader: null
        };
    },
    watch: {
        modelValue: {
            handler (newVal) {
                if (newVal) {
                    this.statusText = '文件已上传成功';
                    this.stsProgress = 100;
                }
            }
        }
    },
    methods: {
        fileChange (e) {
            this.file = e.target.files[0];
            if (!this.file) {
                if (this.modelValue) return;
                this.statusText = "请选择文件";
                this.stsProgress = 0;
                return;
            }
            let userData = '{"Vod":{}}';
            if (this.uploader) {
                this.uploader.stopUpload();
                this.authProgress = 0;
                this.statusText = "请选择文件";
            }
            this.uploader = this.createUploader();
            this.uploader.addFile(this.file, null, null, null, userData);
            this.uploadDisabled = false;
            this.pauseDisabled = true;
            this.resumeDisabled = false;
        },
        // 开始上传
        stsUpload () {
            // 然后调用 startUpload 方法, 开始上传
            if (this.uploader !== null) {
                this.uploader.startUpload();
                this.uploadDisabled = true;
                this.pauseDisabled = false;
            }
        },
        // 暂停上传
        pauseUpload () {
            if (this.uploader !== null) {
                this.uploader.stopUpload();
                this.resumeDisabled = false;
                this.pauseDisabled = true;
            }
        },
        // 恢复上传
        resumeUpload () {
            if (this.uploader !== null) {
                this.uploader.startUpload();
                this.resumeDisabled = true;
                this.pauseDisabled = false;
            }
        },
        createUploader () {
            let self = this;
            let uploader = new AliyunUpload.Vod({
                timeout: self.timeout || 60000,
                partSize: Math.round(self.partSize || 1048576),
                parallel: self.parallel || 5,
                retryCount: self.retryCount || 3,
                retryDuration: self.retryDuration || 2,
                region: self.region,
                userId: self.userId,
                localCheckpoint: true,
                // 添加文件成功
                addFileSuccess: function(uploadInfo) {
                    self.uploadDisabled = false;
                    self.resumeDisabled = false;
                    self.statusText = '添加文件成功, 等待上传...';
                    console.log("addFileSuccess: " + uploadInfo.file.name);
                    self.stsProgress = 0;
                },
                // 开始上传
                onUploadstarted: function(uploadInfo) {
                    // 如果是 STSToken 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
                    // 用户需要自己获取 accessKeyId, accessKeySecret,secretToken
                    // 下面的 URL 只是测试接口, 用于获取 测试的 accessKeyId, accessKeySecret,secretToken
                    // let stsUrl = 'http://demo-vod.cn-shanghai.aliyuncs.com/voddemo/CreateSecurityToken?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=67999yyuuuy&AppVersion=1.0.0'
                    // axios.get(stsUrl).then(({data}) => {
                    // let info = data.SecurityTokenInfo
                    let accessKeyId = 'LTAIdVIqlCmreAo0';
                    let accessKeySecret = 'vVdge1hLso3mkNpffCu8O1nl0PYEoT';
                    let secretToken = 'vVdge1hLso3mkNpffCu8O1nl0PYEoT';
                    uploader.setSTSToken(uploadInfo, accessKeyId, accessKeySecret, secretToken);
                    // })
                    self.statusText = '文件开始上传...';
                    console.log("onUploadStarted:" + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object);
                },
                // 文件上传成功
                onUploadSucceed: function(uploadInfo) {
                    localStorage.setItem('videoId', uploadInfo.videoId);
                    console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object);
                    self.statusText = '文件上传成功!';
                    self.$emit('update:modelValue', uploadInfo.videoId);
                },
                // 文件上传失败
                onUploadFailed: function(uploadInfo, code, message) {
                    console.log("onUploadFailed: file:" + uploadInfo.file.name + ",code:" + code + ", message:" + message);
                    self.statusText = '文件上传失败!';
                },
                // 取消文件上传
                onUploadCanceled: function(uploadInfo, code, message) {
                    console.log("Canceled file: " + uploadInfo.file.name + ", code: " + code + ", message:" + message);
                    self.statusText = '文件已暂停上传';
                },
                // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
                onUploadProgress: function(uploadInfo, totalSize, progress) {
                    console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(progress * 100) + "%");
                    let progressPercent = Math.ceil(progress * 100);
                    self.stsProgress = progressPercent;
                    self.statusText = '文件上传中...';
                },
                // 上传凭证超时
                onUploadTokenExpired: function(uploadInfo) {
                    // 如果是上传方式二即根据 STSToken 实现时，从新获取STS临时账号用于恢复上传
                    // 上传文件过大时可能在上传过程中 sts token 就会失效, 所以需要在 token 过期的回调中调用 resumeUploadWithSTSToken 方法
                    // 这里是测试接口, 所以我直接获取了 STSToken
                    let stsUrl = 'http://demo-vod.cn-shanghai.aliyuncs.com/voddemo/CreateSecurityToken?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=67999yyuuuy&AppVersion=1.0.0';
                    axios.get(stsUrl).then(({ data })=>{
                        let info = data.SecurityTokenInfo;
                        let accessKeyId = info.AccessKeyId;
                        let accessKeySecret = info.AccessKeySecret;
                        let secretToken = info.SecurityToken;
                        let expiration = info.Expiration;
                        uploader.resumeUploadWithSTSToken(accessKeyId, accessKeySecret, secretToken, expiration);
                    });
                    self.statusText = '文件超时...';
                },
                // 全部文件上传结束
                onUploadEnd: function(uploadInfo) {
                    console.log("onUploadEnd: uploaded all the files");
                    self.statusText = '文件上传完毕';
                }
            });
            return uploader;
        }
    }
};
